// Add Declaration wizard upload caps — mirror the server (iscc-backend src/utils/s3.js).
// TODO: hide the wizard's entry points on ISCC CORSIA and on FORWARD shipments — both rejected.
export const MAX_DECLARATION_FILES = 60;
export const MAX_DECLARATION_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const DECLARATION_FILE_ACCEPT = '.pdf';

// The multipart field both write routes read the files from.
export const DECLARATION_FILE_FIELD = 'sustainability_declaration_file';

export const AddDeclarationStep = Object.freeze({ upload: 0, summary: 1 });

// The `declarations` query is newest-updated first and takes no orderBy, so no column sorts.
// TODO: restore per-column sorting once the query accepts a DeclarationOrderBy.
export const DECLARATION_SORT_FIELDS = Object.freeze({});

// The list's filter-panel fields; each is a key DeclarationFilters accepts.
export const DECLARATION_FILTERS = Object.freeze({
  status: 'status',
  materialId: 'materialId',
  sentBySupplierId: 'sentBySupplierId',
});

// declaration_verification_status, as the certificate field reads it.
export const CERTIFICATE_VERIFICATION = Object.freeze({
  verified: 'VERIFIED',
  manuallyVerified: 'MANUALLY_VERIFIED',
  rejected: 'REJECTED',
});

// Column id → ShipmentOrderByField; an unmapped column's sort is dropped server-side.
// TODO: map the rest once ShipmentOrderByField covers them.
export const DECLARATION_LINKED_SHIPMENT_SORT_FIELDS = Object.freeze({
  shipmentId: 'shipmentId',
  dateOfDispatch: 'dateOfDispatch',
});

// The unit every GHG figure is stored and shown in.
// TODO: point ValidateDeclarationSummary's own copy of this literal here too.
export const GHG_EMISSION_UNIT = 'g CO2 e / MJ';

// MassBalancePeriodRow.status — `open` is the period the "Current" badge marks.
export const MASS_BALANCE_PERIOD_STATUS = Object.freeze({
  scheduled: 'SCHEDULED',
  open: 'OPEN',
  closed: 'CLOSED',
});

// The detail page's tabs, in display order.
export const DeclarationDetailTab = Object.freeze({
  overview: 'overview',
  emissionCalculations: 'emissionCalculations',
  declarationDetails: 'declarationDetails',
  linkedShipments: 'linkedShipments',
  allocationDetails: 'allocationDetails',
  attachments: 'attachments',
});

// `inbound_status` — the two states a row action branches on.
export const DECLARATION_STATUS = Object.freeze({
  draft: 'DRAFT',
  processing: 'PROCESSING',
  consumed: 'CONSUMED',
});

// Fully allocated: Figma greys the row and nothing may change its quantities any more.
export const isConsumedDeclaration = (row) => row?.statusValue === DECLARATION_STATUS.consumed;
